/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ContactInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              icon="contact"
              title="Elections Nova Scotia Contact Information"
              description={
                <>
                  <h4>Street Address</h4>
                  <br />
                  202 Brownlow Avenue, Suite 505
                  <br />
                  Dartmouth, Nova Scotia, B3B 1T5
                  <br />
                  <br />
                  <h4>Mailing Address</h4>
                  <br />
                  PO Box 2246
                  <br />
                  Halifax, NS
                  <br />
                  B3J 3C8
                  <br />
                  <br />
                  <h4>Telephone</h4>
                  <br />
                  902-424-8584
                  <br />
                  1-800-565-1504 (Toll free)
                  <br />
                  902-424-7475 (TTY)
                  <br />
                  1-866-774-7074 (Toll Free TTY)
                  <br />
                  902-424-6622 (Fax)
                  <br />
                  <br />
                  <h4>Email</h4>
                  <br />
                  <a href="mailto:elections@novascotia.ca"><i><b><u>elections@novascotia.ca</u></b></i></a>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ContactInformation;
